import { ModelsTransformUtil } from '@ddt-web/common';
import { SharedApplicationConstants } from '@ddt-web/domain';
import { ModelFamiliesUtil } from '@ddt-web/models-screener';
import * as uniq from 'lodash/uniq';
import { Observable, of } from 'rxjs';

import { Categories, ModelFamily, ModelFamilyGroup, ModelPortfolio, ModelsLevelCategories } from '../models';

export class FamiliesUtil {
	public static generateCategoriesModelLevel(families: any): ModelsLevelCategories {
		const modelFamilies: Array<ModelFamily> = Object.values(families?.entities ?? {});
		const familyModelsPerCategory = ModelFamiliesUtil.generateFamilyIdModelsMapping(modelFamilies);
		const groupIdNames = ModelFamiliesUtil.getGroupIdNames(modelFamilies, null, 'models');
		let categories = Object.keys(familyModelsPerCategory);
		const familyIdsPerCategory: { [categoryId: string]: Observable<string[]> } = {};
		let familyList = [];
		// generate list of Observable of family IDs
		Object.entries(familyModelsPerCategory).forEach(([categoryId, familyMapping]) => {
			familyList = Object.keys(familyMapping);
			familyIdsPerCategory[categoryId] = of(familyList);
		});
		categories = FamiliesUtil.moveBlackrockCategoryToEnd(categories);
		return { familyModelsPerCategory, groupIdNames, categories, familyIdsPerCategory };
	}

	public static generateCategories(families: any): Categories {
		const groupIdNames = {};
		let categories = [];
		const familyIdsPerCategory = {};
		const modelFamilies: Array<ModelFamily> = Object.values(families?.entities ?? {});
		const familyIdsPerCate: { [categoryId: string]: string[] } = {};
		modelFamilies.forEach(family => {
			// default family group when sometimes groups is not present
			const defaultGroup = [{
				id: SharedApplicationConstants.MODEL_FAMILY.BLACKROCK_FAMILY_GROUP,
				name: SharedApplicationConstants.MODEL_FAMILY.BLACKROCK_FAMILY_GROUP_TITLE
			}];

			const groups = (family?.groups ?? defaultGroup) as ModelFamilyGroup[];
			groups.forEach(group => {
				if (group.id) {
					familyIdsPerCate[group.id] = familyIdsPerCate[group.id] || [];
					familyIdsPerCate[group.id].push(family.id);

					groupIdNames[group.id] = group.name;
					categories.push(group.id);
				}
			});
		});

		// Convert list of IDs to Observable of IDs
		Object.entries(familyIdsPerCate).forEach(([categoryId, ids]) => {
			familyIdsPerCategory[categoryId] = of(ids);
		});
		categories = uniq(categories);
		categories = FamiliesUtil.moveBlackrockCategoryToEnd(categories);
		return { groupIdNames, categories, familyIdsPerCategory };
	}

	public static moveBlackrockCategoryToEnd(categories: string[]): string[] {
		const response = categories;
		const blackRockIndex = categories.indexOf(SharedApplicationConstants.MODEL_FAMILY.BLACKROCK_FAMILY_GROUP);
		if (blackRockIndex > -1) {
			response.push(categories.splice(blackRockIndex, 1)[0]);
		}
		return response;
	}

	public static getOrderedFamilyHoldingData(families: any, familyId: string, groupId: string, familyHoldings: any, selectedIds: string[] = []) {
		const familyHoldingsData: Array<ModelPortfolio> = [];
		const orderedModelIds = ModelsTransformUtil.sortModelPortfolios(
			families[familyId]?.models.filter(item => item?.groups?.map(element => element.id).includes(groupId) && (selectedIds?.length ? selectedIds.includes(item.id) : true)),
			'dasModelOrder'
		).map(item => item.id);
		orderedModelIds.forEach(modelId => familyHoldingsData.push(familyHoldings?.entities?.[modelId]));
		return familyHoldingsData;
	}
}
